export default __webpack_public_path__ + "static/2188-b209697b10f34c5cb6e501a5ea994426.gif";